/* Beltly scroll reveal — IntersectionObserver, editor-safe.
   No scroll listeners, no layout thrash. */
(function () {
  var d = document, root = d.documentElement;

  // Skip inside the Shopify theme editor and for reduced-motion users.
  if (window.Shopify && Shopify.designMode) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  root.classList.add('beltly-anim');

  function init() {
    var sections = d.querySelectorAll('main .shopify-section:not(:first-child)');
    if (!sections.length) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('beltly-inview');
            io.unobserve(e.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );

    sections.forEach(function (s) {
      // Anything already in the viewport on load shows instantly (no LCP hit).
      var r = s.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.9) {
        s.classList.add('beltly-inview');
      } else {
        io.observe(s);
      }
    });
  }

  if (d.readyState === 'loading') {
    d.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Beltly: skip entrance animations on back/forward navigation —
   re-revealing a page the user has already seen reads as lag.
   Runs in the same pre-paint task as the reveal init above, so
   there is no flash. bfcache restores keep their classes anyway. */
(function () {
  var entries = performance.getEntriesByType ? performance.getEntriesByType('navigation') : [];
  var nav = entries && entries[0];
  if (nav && nav.type === 'back_forward') {
    document.documentElement.classList.remove('beltly-anim');
  }
})();

/* Beltly: lazy-image fade-in — additive; same guards as the reveal above. */
(function () {
  var d = document;
  if (window.Shopify && Shopify.designMode) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function mark(img) { img.classList.add('beltly-img-in'); }

  // Capture-phase listeners also catch images added later by
  // pagination or section re-renders (load/error don't bubble).
  d.addEventListener('load', function (e) {
    var t = e.target;
    if (t instanceof HTMLImageElement && t.loading === 'lazy') mark(t);
  }, true);
  d.addEventListener('error', function (e) {
    var t = e.target;
    if (t instanceof HTMLImageElement && t.loading === 'lazy') mark(t);
  }, true);

  function init() {
    d.querySelectorAll('main img[loading="lazy"]').forEach(function (img) {
      if (img.complete) mark(img);
    });
  }

  if (d.readyState === 'loading') {
    d.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Beltly: footer reveal — mirrors the main-content reveal above. */
(function () {
  var d = document;
  if (window.Shopify && Shopify.designMode) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  function init() {
    var sections = d.querySelectorAll('.page-wrapper > footer .shopify-section');
    if (!sections.length) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('beltly-inview');
            io.unobserve(e.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );

    sections.forEach(function (s) {
      var r = s.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.9) {
        s.classList.add('beltly-inview');
      } else {
        io.observe(s);
      }
    });
  }

  if (d.readyState === 'loading') {
    d.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Beltly v4: headline character reveal — headings rise letter by letter.
   Same guards as everything above; skips headings with non-text children
   (except <br>), the scroll story (own choreography), and jumbo text
   (Horizon's own reveal effect). Screen readers get the original string
   via aria-label; the char spans are aria-hidden. */
(function () {
  var d = document;
  if (window.Shopify && Shopify.designMode) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  function splittable(h) {
    if (h.dataset.beltlySplit) return false;
    if (h.closest('.beltly-story, .jumbo-text, jumbo-text, header-component, .beltly-noreveal')) return false;
    var txt = h.textContent.trim();
    if (!txt || txt.length > 80) return false;
    for (var n = h.firstChild; n; n = n.nextSibling) {
      if (n.nodeType === 1 && n.tagName !== 'BR') return false;
      if (n.nodeType !== 1 && n.nodeType !== 3) return false;
    }
    return true;
  }

  function split(h) {
    h.dataset.beltlySplit = '1';
    var label = '';
    (function walk(node) {
      for (var n = node.firstChild; n; n = n.nextSibling) {
        if (n.nodeType === 3) label += n.textContent;
        else if (n.tagName === 'BR') label += ' ';
      }
    })(h);
    h.setAttribute('aria-label', label.replace(/\s+/g, ' ').trim());
    var idx = 0;
    var nodes = Array.prototype.slice.call(h.childNodes);
    nodes.forEach(function (node) {
      if (node.nodeType !== 3) return; /* keep <br> etc */
      var frag = d.createDocumentFragment();
      node.textContent.split(/(\s+)/).forEach(function (part) {
        if (!part) return;
        if (/^\s+$/.test(part)) {
          frag.appendChild(d.createTextNode(' '));
          return;
        }
        var w = d.createElement('span');
        w.className = 'beltly-word';
        w.setAttribute('aria-hidden', 'true');
        for (var i = 0; i < part.length; i++) {
          var c = d.createElement('span');
          c.className = 'beltly-char';
          c.style.transitionDelay = Math.min(idx * 22, 550) + 'ms';
          c.textContent = part[i];
          w.appendChild(c);
          idx++;
        }
        frag.appendChild(w);
      });
      h.replaceChild(frag, node);
    });
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('beltly-chars-in');
        io.unobserve(e.target);
      }
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.2 });

  function init() {
    d.querySelectorAll('main h1, main h2').forEach(function (h) {
      if (splittable(h)) {
        split(h);
        io.observe(h);
      }
    });
  }

  if (d.readyState === 'loading') {
    d.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Beltly v4: magnetic pills — primary and secondary buttons drift a few
   pixels toward the cursor and spring back. Fine pointers only, motion-safe. */
(function () {
  var d = document;
  if (window.Shopify && Shopify.designMode) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var MAX = 5;
  var FACTOR = 0.18;

  d.addEventListener('pointerover', function (e) {
    var btn = e.target.closest && e.target.closest('.button, .button-secondary');
    if (!btn || btn.dataset.beltlyMag) return;
    btn.dataset.beltlyMag = '1';

    function move(ev) {
      var r = btn.getBoundingClientRect();
      var x = (ev.clientX - (r.left + r.width / 2)) * FACTOR;
      var y = (ev.clientY - (r.top + r.height / 2)) * FACTOR;
      x = Math.max(-MAX, Math.min(MAX, x));
      y = Math.max(-MAX, Math.min(MAX, y));
      btn.style.setProperty('--beltly-mx', x.toFixed(1) + 'px');
      btn.style.setProperty('--beltly-my', y.toFixed(1) + 'px');
    }
    function leave() {
      btn.style.setProperty('--beltly-mx', '0px');
      btn.style.setProperty('--beltly-my', '0px');
    }
    btn.addEventListener('pointermove', move);
    btn.addEventListener('pointerleave', leave);
  });
})();
